import { render, staticRenderFns } from "./TableImportErrorGlobal.vue?vue&type=template&id=10f24338&scoped=true"
import script from "./TableImportErrorGlobal.vue?vue&type=script&lang=js"
export * from "./TableImportErrorGlobal.vue?vue&type=script&lang=js"
import style0 from "./TableImportErrorGlobal.vue?vue&type=style&index=0&id=10f24338&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f24338",
  null
  
)

export default component.exports